import isEmpty from 'lodash/isEmpty';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {renderMunicipality, renderProvince} from '@/utils/location';

export const useAddressFull = (address, hideDpa = false, defaultValue = '-') => {
  const {t} = useTranslation('common');

  return useMemo(() => {
    if (isEmpty(address)) return defaultValue;

    const dpaText = !hideDpa ? `${t('municipality')} ${address?.municipality ? renderMunicipality(address?.municipality) : '-'} ${t('province')} ${address?.province ? renderProvince(address?.province) : '-'}` : '';

    return `${address?.abstract} ${dpaText}`;
  }, [address, defaultValue, hideDpa, t]);
};
